import script from "./AuthGuestView.vue?vue&type=script&lang=js"
export * from "./AuthGuestView.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__